import script from "./NavLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./NavLinks.vue?vue&type=script&setup=true&lang=js"

import "./NavLinks.vue?vue&type=style&index=0&id=09147637&lang=css"

const __exports__ = script;

export default __exports__